<template>
<div id="transferManage">
  <div class="search">
    <div class="tabTit">
      <ul>
        <li :class="curMenu === '0'?'cur':''" @click="setCurMenu('0')">O2O商品</li>
        <li :class="curMenu === '1'?'cur':''" @click="setCurMenu('1')">实物商品</li>
        <li :class="curMenu === '2'?'cur':''" @click="setCurMenu('2')">卡包专区</li>
        <li :class="curMenu === '3'?'cur':''" @click="setCurMenu('3')">合伙人商品</li>
      </ul>
      <div class="clearFix"></div>
    </div>
  </div>
  <div class="search">
    <div class="searchInline">
      <el-input v-model="searchParams.selectName" placeholder="请输入商品名称" clearable></el-input>
    </div>
    <div class="searchInline" v-if="curMenu === '0' || curMenu === '1'">
      <el-select @change="submitGoodsType" v-model="searchParams.gcParentId" placeholder="请选择分类">
        <el-option  :label="item.gcName" :value="item.gcId" v-for="(item, index) in goodsTypeList" :key='index'></el-option>
      </el-select>
    </div>
    <div class="searchInline" v-if="curMenu === '0' || curMenu === '1'">
      <el-select v-model="searchParams.classId" @change="submitSearch" placeholder="请选择二级分类">
        <el-option :label="item.gcName" :value="item.gcId" v-for="(item, index) in goodsTypeListSub" :key='index'></el-option>
      </el-select>
    </div>
    <div class="searchInline" v-if="curMenu === '3'">
      <el-select v-model="searchParams.goodsCatagory" @change="submitSearch" placeholder="请选择分类" clearable>
        <el-option label="O2O" :value="0"></el-option>
        <el-option label="实物" :value="1"></el-option>
        <el-option label="VIP" :value="2"></el-option>
        <!-- <el-option label="SVIP" :value="3"></el-option> -->
        <el-option label="卡包" :value="4"></el-option>
      </el-select>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="submitSearch">搜索</el-button>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="searchClear()">清除</el-button>
    </div>
  </div>
  <div class="contentView">
    <el-table key='product' :data="tableData" v-if="curMenu === '0' || curMenu === '1'" style="width: 100%;">
      <el-table-column
        prop="goodsCommonId"
        label="商品ID"
        min-width="100">
      </el-table-column>
      <el-table-column prop="resource" label="商品图片">
        <template slot-scope="scope">
          <img :src="scope.row.goodsImage" style="width: 60px; height: 60px"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="skuCount"
        label="规格数"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="gcName"
        label="商品分类"
        min-width="100">
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmit(scope.row)">查看详情</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 卡包相关 -->
    <el-table key='cardBag' :data="tableData" v-else-if="curMenu === '2'" style="width: 100%;">
      <el-table-column
        prop="goodsCommonId"
        label="卡片ID"
        min-width="100">
      </el-table-column>
      <el-table-column prop="resource" label="卡片图片">
        <template slot-scope="scope">
          <img :src="scope.row.goodsImage" style="width: 60px; height: 60px"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="卡片名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="skuCount"
        label="权益数"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="buyPrice"
        label="购买价格"
        min-width="100">
      </el-table-column>
      <!-- <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmit(scope.row)">查看详情</span>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 合伙人的 -->
    <el-table key='hehuoren' :data="tableData" v-else-if="curMenu === '3'" style="width: 100%;">
      <el-table-column prop="resource" label="商品图片">
        <template slot-scope="scope">
          <img :src="scope.row.goodsImage" style="width: 60px; height: 60px"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="buyPrice"
        label="分类"
        min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.goodsCatagory === 0">O2O商品</span>
          <span v-if="scope.row.goodsCatagory === 1">实物</span>
          <span v-if="scope.row.goodsCatagory === 2">VIP</span>
          <span v-if="scope.row.goodsCatagory === 3">SVIP</span>
          <span v-if="scope.row.goodsCatagory === 4">卡包</span>
        </template>
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmitHhr(scope.row)">查看详情</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult"
      ></el-pagination>
    </div>
  </div>

  <el-dialog title="提交确认" :visible.sync="dialog.submit.show" width="900px">
    <div class="lay-t-a-c">
    <div class="search">
      <div class="title">
        <div class="searchInline">
          <p>商品ID:{{dialog.submit.goodsCommonId}}</p>
          <p style="margin-left: 40px;">商品名称:{{dialog.submit.goodsName}}</p>
        </div>
      </div>
    </div>
      <div class="searchInline">
        <el-table :data="tableDetail" v-if="curMenu !== '3'" style="width: 100%;">
          <el-table-column
            prop="goodsName"
            label="规格名称"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsId"
            label="规格id"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="defaultSaleNum"
            label="默认销量"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsStorage"
            label="库存"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsPrice"
            label="销售价"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsVipPrice"
            label="VIP价"
            min-width="100">
          </el-table-column>
          <el-table-column
          v-if="curMenu !== '1'"
            prop="goodsJsprice"
            label="结算价"
            min-width="100">
          </el-table-column>
          <el-table-column
            v-if="curMenu === '1'"
            prop="goodsCostprice"
            label="进货价"
            min-width="100">
          </el-table-column>
          <el-table-column
            class="tableOptions"
            label="操作"
            min-width="150">
            <template slot-scope="scope">
              <span class="to_able" @click="copyUrl(scope.row)">复制URL</span>
              <span class="to_able" @click="addJson(scope.row)">生成JSON</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 合伙人的 -->
        <el-table :data="tableDetail" v-if="curMenu === '3'" style="width: 100%;">
          <el-table-column
            prop="goodsName"
            label="规格名称"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsStorage"
            label="库存"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsPrice"
            label="销售价"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="goodsVipPrice"
            label="VIP价"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="divideIntoType"
            label="分成策略"
            min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.divideIntoType === 0">固定分成</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directlyDivided"
            label="直接"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="indirectDivision"
            label="间接"
            min-width="100">
          </el-table-column>
          <el-table-column
            class="tableOptions"
            v-if="isShowCz"
            label="操作"
            min-width="150">
            <template slot-scope="scope">
              <span class="to_able" @click="copyUrl(scope.row)">复制URL</span>
              <span class="to_able" @click="addJsonHHR(scope.row)">生成JSON</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <input type="text" id="inputValue" style="opacity: 0" value="" v-model="conment" name="">
    <div class="dialogSubmitBtns">
      <el-button type="primary" @click="submitConfirm()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      conment: '',
      curMenu: '0',
      searchParams: {
        gcParentId: '',
        classId: '',
        selectName: '',
        goodsCatagory: '',
        catagory: '',
        gcId: '',
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      goodsTypeList: [],
      goodsTypeListSub: [],
      tableData: [],
      tableDetail: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      isShowCz: false,
      dialog: {
        submit: {
          show: false,
          goodsName: '',
          goodsCommonId: ''
        }
      }
    };
  },
  created () {
    this.getList();
    this.getClassList();
  },
  methods: {
    // 获取列表数据
    getList () {
      if (this.searchParams.classId === '') {
        this.axios.get('/member/recommondGoodsList' + devCode, {
          params: {
            selectName: this.searchParams.selectName,
            catagory: this.curMenu,
            goodsCatagory: this.searchParams.goodsCatagory,
            gcId: this.searchParams.gcParentId,
            pageIndex: this.searchParams.pageIndex,
            pageSize: this.searchParams.pageSize
          }
        }).then(res => {
          console.log(res);
          if (res.data.isSuccess) {
            this.tableData = res.data.resultData.content;
            this.totalResult = res.data.resultData.total;
            this.totalPage = res.data.resultData.pageTotal;
          };
        });
      } else {
        this.axios.get('/member/recommondGoodsList' + devCode, {
          params: {
            selectName: this.searchParams.selectName,
            catagory: this.curMenu,
            gcId: this.searchParams.classId,
            pageIndex: this.searchParams.pageIndex,
            pageSize: this.searchParams.pageSize
          }
        }).then(res => {
          console.log(res);
          if (res.data.isSuccess) {
            this.tableData = res.data.resultData.content;
            this.totalResult = res.data.resultData.total;
            this.totalPage = res.data.resultData.pageTotal;
          };
        });
      }
    },
    // 获取分类列表数据
    getClassList () {
      this.axios.get('/member/getGoodsClass' + devCode, {
        params: {
          catagory: this.curMenu
        }
      }).then(response => {
        console.log(response);
        let res = response.data;
        if (res.ok) {
          this.goodsTypeList = res.data;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    //  选择商品分类显示二级
    submitGoodsType () {
      let goodsTypeId = this.searchParams.gcParentId;
      let goodsTypeList = this.goodsTypeList;
      let goodsTypeListSelected = goodsTypeList.filter(item => {
        return goodsTypeId === item.gcId;
      });
      console.log(goodsTypeListSelected);
      this.goodsTypeListSub = goodsTypeListSelected[0].childList || [];
      this.searchParams.classId = '';
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 点击顶部商品类型
    setCurMenu (num) {
      console.log(num);
      if (num === '0') {
        this.curMenu = '0';
      } else if (num === '1') {
        this.curMenu = '1';
      } else if (num === '2') {
        this.curMenu = '2';
      } else {
        this.curMenu = '3';
      }
      this.searchClear();
      this.getClassList();
      // this.getList();
    },
    // 清除列表的搜索表单
    searchClear () {
      this.searchParams = {
        selectName: '',
        Name: '',
        isAccount: '',
        classId: '',
        gcId: '',
        pageSize: 10,
        pageIndex: 0
      };
      this.goodsTypeListSub = [];
      this.getList();
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 打开详情
    openSubmit (obj) {
      console.log(obj);
      this.ids = obj.id;
      this.dialog.submit.show = true;
      this.dialog.submit.goodsName = obj.goodsName;
      this.dialog.submit.goodsCommonId = obj.goodsCommonId;
      // 获取列表数据
      this.axios.get('/member/recommondGoodsDetail' + devCode, {
        params: {
          goodsCommonId: obj.goodsCommonId
        }
      }).then(res => {
        console.log(res);
        if (res.data.isSuccess) {
          this.tableDetail = res.data.resultData;
        };
      });
    },
    // 打开合伙人的详情
    openSubmitHhr (obj) {
      console.log(obj);
      this.ids = obj.id;
      this.dialog.submit.show = true;
      this.dialog.submit.goodsName = obj.goodsName;
      this.dialog.submit.goodsCommonId = obj.goodsCommonId;
      // 获取 managerId
      this.axios.get('/doubleTask/getManagerId' + devCode, {
        params: {
        }
      }).then(res => {
        console.log(res, '99');
        if (res.data.isSuccess) {
          // 获取详情数据
          this.axios.get('/member/recommondAgentGoodsDetail' + devCode, {
            params: {
              managerId: res.data.resultData.managerId,
              productId: obj.goodsCommonId
            }
          }).then(res => {
            console.log(res);
            if (res.data.isSuccess) {
              this.tableDetail = res.data.resultData;
              this.dialog.submit.goodsCommonId = res.data.resultData[0].goodsCommonid;
              if (res.data.resultData[0].agentType === 0 || res.data.resultData[0].agentType === 1) {
                this.isShowCz = true;
              } else {
                this.isShowCz = false;
              }
            };
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    submitConfirm () {
      this.dialog.submit.show = false;
    },
    // 复制url
    copyUrl (item) {
      console.log(item);
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        let goodsIdUrl = `?goodsCommonId=${item.goodsCommonid}&goodsId=${item.goodsId}&busiType=${this.busiType}&agtSN=${item.agentCode || ''}`;
        ceshiurl = 'https://www.youtoo365.com' + '/webApp/nearby/product' + goodsIdUrl;
      } else {
        let goodsIdUrl = `?goodsCommonId=${item.goodsCommonid}&goodsId=${item.goodsId}&agtSN=${item.agentCode || ''}`;
        ceshiurl = 'http://218.29.121.74:8081' + '/webApp/nearby/product' + goodsIdUrl;
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    },
    // 生成JSON
    addJson (item) {
      console.log(item);
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        let aa = {
          'type': 'Shop',
          'goodsName': item.goodsName,
          'goodsCommonId': item.goodsCommonid,
          'goodsId': item.goodsId,
          'imageUrl': 'https://static002.youtoo365.com/' + item.goodsImage,
          'goodsPrice': item.goodsPrice,
          'goodsVipPrice': item.goodsVipPrice,
          'url': 'https://www.youtoo365.com/webApp/nearby/product'
        };
        ceshiurl = 'youtuchefu' + JSON.stringify(aa);
      } else {
        let aa = {
          'type': 'Shop',
          'goodsName': item.goodsName,
          'goodsCommonId': item.goodsCommonid,
          'goodsId': item.goodsId,
          'imageUrl': 'https://static002.youtoo365.com/' + item.goodsImage,
          'goodsPrice': item.goodsPrice,
          'goodsVipPrice': item.goodsVipPrice,
          'url': 'http://dev3.yotur.cn/webApp/nearby/product'
        };
        ceshiurl = 'youtuchefu' + JSON.stringify(aa);
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    },
    // 生成JSON合伙人
    addJsonHHR (item) {
      console.log(item);
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        let aa = {
          'type': 'Shop',
          'goodsName': item.goodsName,
          'goodsCommonId': item.goodsCommonid,
          'goodsId': item.goodsId,
          'imageUrl': item.goodsImage,
          'goodsPrice': item.goodsPrice,
          'goodsVipPrice': item.goodsVipPrice,
          'agtSN': item.agentCode,
          'url': 'https://www.youtoo365.com/webApp/nearby/product'
        };
        ceshiurl = 'youtuchefu' + JSON.stringify(aa);
      } else {
        let aa = {
          'type': 'Shop',
          'goodsName': item.goodsName,
          'goodsCommonId': item.goodsCommonid,
          'goodsId': item.goodsId,
          'imageUrl': item.goodsImage,
          'goodsPrice': item.goodsPrice,
          'goodsVipPrice': item.goodsVipPrice,
          'agtSN': item.agentCode,
          'url': 'http://dev3.yotur.cn/webApp/nearby/product'
        };
        ceshiurl = 'youtuchefu' + JSON.stringify(aa);
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    }
  }
};
</script>
<style lang="scss" scoped>
.tabTit {
  background: #fff;
  margin-bottom: 20px;
}
.tabTit li {
  float: left;
  line-height: 30px;
  font-size: 14px;
  padding: 0 10px;
  cursor: pointer;
  position: relative;
}
.tabTit li.cur {
  color: #409eff;
  font-weight: bold;
}
.tabTit li.cur:before {
  display: block;
  width: 100%;
  left: 0;
  bottom: -2px;
  content: ' ';
  height: 2px;
  background:#409eff;
  position: absolute;
}
.title{
  height: 80px;
  width: 100%;
  background: #f4f4f4;
  padding: 20px 30px;
}
.title .searchInline{
  width: 70%;
  display: flex;
  font-size: 16px;
}
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
</style>



// WEBPACK FOOTER //
// src/components/serveRecd/ProductRecd.vue